"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal, Stagger, StaggerItem } from "@/components/shared/motion";
import { ShoppingCart, QrCode, Wifi } from "lucide-react";

/** Bold 3-step quick onboarding. Anchor target for the hero "how it works". */
export default function Steps3() {
  const { t } = useTranslations();
  const steps = [
    { n: "01", icon: ShoppingCart, title: t("cobra.steps.1.title", "Pick your plan"), desc: t("cobra.steps.1.desc", "Choose a destination and a data plan that fits your trip.") },
    { n: "02", icon: QrCode, title: t("cobra.steps.2.title", "Scan the QR"), desc: t("cobra.steps.2.desc", "Get your QR code by email and install the eSIM in your settings.") },
    { n: "03", icon: Wifi, title: t("cobra.steps.3.title", "Go online"), desc: t("cobra.steps.3.desc", "Land, switch on data, and connect in minutes.") },
  ];

  return (
    <section id="how" className="border-y-2 border-foreground bg-muted/40">
      <div className="container mx-auto px-4 py-14">
        <Reveal as="h2" y={18} duration={0.4} className="text-3xl sm:text-4xl text-center">{t("cobra.steps.heading", "Online in three moves")}</Reveal>
        <Stagger as="div" staggerChildren={0.1} className="mt-10 grid md:grid-cols-3 gap-5">
          {steps.map(({ n, icon: Icon, title, desc }) => (
            <StaggerItem key={n} y={24} duration={0.4} className="relative border-2 border-foreground bg-card p-6 shadow-[6px_6px_0_0_hsl(var(--foreground))] transition-transform hover:-translate-x-0.5 hover:-translate-y-0.5">
              <span className="display-xl absolute -top-4 -left-3 text-5xl text-primary/30 select-none" aria-hidden="true">{n}</span>
              <div className="inline-flex items-center justify-center w-12 h-12 border-2 border-foreground bg-primary text-primary-foreground mb-3">
                <Icon className="w-5 h-5" />
              </div>
              <h3 className="text-xl">{title}</h3>
              <p className="mt-1.5 text-sm text-foreground/75 font-medium normal-case">{desc}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
